import { useNavigate } from 'react-router-dom';
import Footer from '@/components/Footer';
import { ArrowLeft } from 'lucide-react';
import { useDocumentMeta } from '@/hooks/useDocumentMeta';

export default function AffiliateDisclosure() {
  const navigate = useNavigate();

  useDocumentMeta({
    title: 'Affiliate Disclosure, Mementa',
    description: 'How Mementa earns commissions from affiliate partners.',
    url: 'https://mementa.gifts/affiliate-disclosure',
  });

  return (
    <div className="min-h-screen bg-[#FFF8F0] page-enter">
      <div className="max-w-4xl mx-auto px-4 py-12">
        <button
          onClick={() => navigate('/browse')}
          className="flex items-center gap-2 mb-6 px-4 py-2 rounded-full transition-all text-[#9E6752] hover:bg-[#9E6752] hover:!text-white border-2"
          style={{ borderColor: '#9E6752' }}
          data-testid="affiliate-disclosure-back-button"
        >
          <ArrowLeft size={20} />
          <span className="font-medium">Back to Browse</span>
        </button>

        <h1 className="text-4xl font-bold mb-8" style={{ fontFamily: 'Playfair Display, serif', color: '#20212B' }}>
          Affiliate Disclosure
        </h1>

        <div className="bg-white rounded-xl p-8 shadow-sm space-y-5 text-base leading-relaxed" style={{ color: '#534145' }} data-testid="affiliate-disclosure-content">
          <p>
            <strong>Mementa is a curation service, not a store.</strong> We do not sell products
            directly. When you find a gift you love on Mementa, we send you to the merchant's
            website (such as Etsy, Amazon, or Target) to complete your purchase.
          </p>
          <p>
            <strong>We may earn a commission.</strong> Many of the product links on this site are
            affiliate links. If you click one and make a qualifying purchase, Mementa may earn a
            commission from the merchant or its affiliate network, including Rakuten Advertising,
            which manages our partnership with Etsy. <strong>This comes at no additional cost to
            you</strong>, you pay exactly the same price you would pay by visiting the merchant
            directly.
          </p>
          <p>
            <strong>Commissions never influence our curation.</strong> Every product on Mementa is
            hand-picked because we believe it makes a genuinely thoughtful gift. We do not accept
            payment for placement, and our recommendations are based on the person you are shopping
            for, not on which link pays the most.
          </p>
          <p>
            <strong>About AI-assisted content.</strong> Some product descriptions and gift
            recommendations on Mementa are generated or refined with the help of artificial
            intelligence, based on merchant-provided information. We review this content, but
            details like price and availability can change; always confirm them on the merchant's
            site before purchasing.
          </p>
          <p>
            This disclosure is provided in accordance with the United States Federal Trade
            Commission's guidelines on endorsements and testimonials (16 CFR Part 255).
          </p>
          <p>
            Questions? Contact us at{' '}
            <a href="mailto:affiliate@mementa.gifts" className="underline" style={{ color: '#9E6752' }}>
              affiliate@mementa.gifts
            </a>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  );
}
